import axios from 'axios'

const LOGIN = 'LOGIN'
const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
const LOGOUT = 'LOGOUT'

const state = {
  isLoggedIn: !!sessionStorage.getItem('token'),
  pending: false,
  profile: {}
}
const mutations = {
  [LOGIN] (state) {
    state.pending = true
  },
  [LOGIN_SUCCESS] (state, payload) {
    state.isLoggedIn = true
    state.pending = false
  },
  [LOGOUT] (state) {
    state.isLoggedIn = false
    state.profile = {}
  },
  SET_PROFILE (state, payload) {
    state.profile = payload
  },
  GET_TOKEN (state) {
    state.pending = true
  },
  CHECKING_LOGIN (state) {
    state.pending = true
  },
  LOGIN_FAILED (state) {
    state.pending = false
    state.isLoggedIn = false
    sessionStorage.removeItem('token')
  }
}

const actions = {
  login ({ commit }) {
    commit(LOGIN) // show spinner
    window.open(
      process.env.VUE_APP_OAUTH_AUTH_URL +
        '?scope=read&response_type=code&client_id=' +
        process.env.VUE_APP_OAUTH_CLIENT_ID +
        '&redirect_uri=' +
        location.origin +
        '/login',
      '_parent'
    )
  },
  logout ({ commit, state }) {
    /* axios
      .get(`${process.env.VUE_APP_OAUTH_URL}/${state.activeLanguage}/user/logout`, {
      })
      .then(result => {
        commit(LOGOUT)
      })
      .catch(err => {
        console.error(err)
      }) */
    sessionStorage.removeItem('token')
    sessionStorage.removeItem('refresh_token')
    sessionStorage.removeItem('atoken')
    commit(LOGOUT)
  },
  getJWT ({ commit }, data) {
    axios
      .get(process.env.VUE_APP_ROOT_API + '/api/V2/login/getMyJWT', {
        headers: {
          Authorization: 'Bearer ' + data.access_token
        }
      })
      .then(result => {
        if (result.data.token) {
          sessionStorage.setItem('token', result.data.token)
          commit(LOGIN_SUCCESS)
        } else {
          commit('LOGIN_FAILED')
        }
        // router.replace('/')
      })
      .catch(() => {
        commit('LOGIN_FAILED')
      })
  },
  getToken ({ commit, dispatch }, code) {
    commit('GET_TOKEN')
    const params = new URLSearchParams()
    params.append('grant_type', 'authorization_code')
    params.append('client_id', process.env.VUE_APP_OAUTH_CLIENT_ID)
    params.append('redirect_uri', location.origin + '/login')
    params.append('code', code)
    axios
      .post(process.env.VUE_APP_OAUTH_TOKEN_URL, params, {
        headers: {
          Authorization:
              'Basic ' +
              btoa(
                process.env.VUE_APP_OAUTH_CLIENT_ID +
                  ':' +
                  process.env.VUE_APP_OAUTH_CLIENT_SECRET
              )
        }
      })
      .then(result => {
        if (result.data.access_token) {
          sessionStorage.setItem('atoken', result.data.access_token)
          dispatch('getJWT', result.data)
        } else {
          commit('LOGIN_FAILED')
        }
        // router.replace('/')
      })
      .catch(e => {
        commit('LOGIN_FAILED')
      })
  },
  getProfile ({ commit, dispatch }, payload) {
    commit('CHECKING_LOGIN')
    axios
      .get(process.env.VUE_APP_OAUTH_PROFILE_URL, {
        params: payload.params
      })
      .then(result => {
        commit('SET_PROFILE', result.data)
        dispatch('CHANGE_ACTIVE_LANGUAGE', result.data.preferredLanguage)
      })
      .catch(() => {
        commit('LOGIN_FAILED')
      })
  }
}

const getters = {
  isLoggedIn: state => {
    return state.isLoggedIn
  },
  userRoles: state => {
    return state.profile.roles
  },
  profile: state => {
    return state.profile
  }
}

export default { state, getters, mutations, actions }
